import { render } from "./AppLayoutDashboard.vue?vue&type=template&id=5c0c28c6&ts=true"
import script from "./AppLayoutDashboard.vue?vue&type=script&lang=ts"
export * from "./AppLayoutDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__